export const thresholdKeys = ['danger', 'alert', 'warning', 'ok', 'excessive', 'noData']
